import z from "zod";

// Note: the `description` is displayed in a <pre> block so don't change the whitespace
export const subaccountSettingDefinitions = {
  donationHistoryPage: {
    name: "Donation history features",
    description: `The donation history features allow your subaccount admins to leverage your donation history to create stronger fundraising-related campaigns. 
If the donation history features are turned on AND the subaccount has donations that have been synced from an ActBlue webhook integration, 
the subaccount admins will be able to:

• View a donation history tab that includes detailed information for all ActBlue donations synced to Scale to Win Text including donation amount, 
  donor name, address, phone number and source.
• Filter their list of short code contacts by donation history (eg total donation, last donation date, etc.)
• Customize their messages using donation history information (eg "Thank you for donating $25 last month! Will you support us again this month?).

Please Note: Data synced from ActBlue may include donations made outside of Scale to Win Text campaigns.`,
    type: z.boolean(),
    default: false,
  },
};

export const AllSubaccountSettingsSchema = z.object(
  Object.fromEntries(
    Object.entries(subaccountSettingDefinitions).map(([name, def]) => [
      name,
      def.type,
    ])
  )
);

export type SubaccountSettingKey = keyof typeof subaccountSettingDefinitions;

export type AllSubaccountSettings = {
  [K in SubaccountSettingKey]: z.infer<
    (typeof subaccountSettingDefinitions)[K]["type"]
  >;
};

export function parseSubaccountSettings(
  settings: Record<string, any>
): AllSubaccountSettings {
  const defaults = Object.entries(subaccountSettingDefinitions).reduce(
    (acc, entry) => {
      const [key, val] = entry;
      acc[key as SubaccountSettingKey] = val.default;
      return acc;
    },
    {} as AllSubaccountSettings
  );

  return AllSubaccountSettingsSchema.parse({
    ...defaults,
    ...settings,
  }) as AllSubaccountSettings;
}
